import { useNavigate ,useLocation} from "react-router-dom";
import { useState,useEffect  } from "react";

import  Calculator  from "../../components/ui/Calculator"; // update path as needed



import { UserRoundCog } from "lucide-react";

const MyProfile = () => {

     const navigate = useNavigate();
  const location = useLocation();
  

   const [activeButton,setActiveButton]=useState('');
  

  useEffect(() => {
      if (location.pathname.includes("/myprofile")) {
        setActiveButton("myprofile");
      } else if (location.pathname.includes("/livesupport")) {
        setActiveButton("livesupport");
      } else {
        setActiveButton(""); // default
      }
    }, [location.pathname]);
    const [showCalculator, setShowCalculator] = useState(false);

  return (
    <div className=" flex text-textColor  bg-customGray font-sans min-h-screen">

      <div className="flex flex-col w-4/5 flex-1  p-0">
        <div className="flex items-center justify-between bg-white px-4 py-2 shadow-sm border-b">
          {/* Left: icon and Breadcrumbs */}
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2">
              <UserRoundCog />
              <span className="font-bold text-lg">My Profile</span>
            </div>
            <div className="text-[13px] text-gray-500 space-x-2 hidden sm:flex">
              <span>Carriers</span>
              <span>•</span>
              <span>Loads Report</span>
              <span>•</span>
              <span
  className="cursor-pointer text-gray-500 hover:text-greenBg"
  onClick={() => setShowCalculator(true)}
>
  Calculator
</span>

              <span>•</span>
              <span>View Asset Map</span>
              <span>•</span>
            </div>
          </div>
          <div className="px-4 py-1 items-center space-x-1">
            <button className="bg-customOrange hover:bg-greenBg text-white text-sm font-semibold px-4 py-1 rounded-md space-x-1 shadow-[1px_2px_2px_rgba(0,0,0,0.3)]">
              Save
            </button>
          </div>
        </div>

        <div className="min-h-screen bg-gray-100 px-4 py-2">
          <div className="bg-white w-full h-full rounded-xl">
            <form>
              <div>
                <div className=" text-[13px]">
                  <div className="bg-white  px-2  mb-[2px]  flex flex-wrap space-x-2 lg:space-x-2 w-full rounded-2xl ">
                    <div className="relative flex py-2 gap-2  ">
                    <button className={` px-2 py-1 text-sm  lg:px-4 lg:py-1  rounded-md font-medium shadow-sm 
                      ${activeButton ==='myprofile' ? 'bg-greenBg text-white' : ' bg-customGray hover:bg-greenBg hover:text-white'}`} onClick={()=>{
                      navigate('/myprofile')
                    }}>
                      My Profile
                    </button>
                   
                    </div>
                  </div>
                  <div className="flex w-full gap-2">
                    <div className="w-3/5">
                      <p className="flex  p-2 items-center">
                        <label for="timezone" className="w-2/5">
                          Full Name
                        </label>
                        <input
                          type="text"
                          name="name"
                          id="name"
                          placeholder="Awahe CA"
                          required
                          className=" border border-customGray  hover:border-greenBg  rounded-lg bg-customGray w-full px-2 py-2 focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                        />
                      </p>
                      <p className="flex p-2 items-center">
                        <label for="timezone" className="w-2/5">
                          Address 1
                        </label>
                        <input
                          type="text"
                          name="address"
                          id="address"
                          placeholder="231 N Tracy Blvd , Tracy CA 95376"
                          required
                          className="border border-customGray   hover:border-greenBg rounded-lg bg-customGray w-full px-2 py-2 focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                        />
                      </p>
                      <p className="flex  p-2 items-center">
                        <label for="timezone" className="w-2/5">
                          Address 2
                        </label>
                        <input
                          type="text"
                          name="address2"
                          id="address2"
                          required
                          className="border border-customGray  hover:border-greenBg  rounded-lg bg-customGray w-full px-2 py-2 focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                        />
                      </p>

                      <p className="flex p-2 items-center">
                        <label for="timezone" className="w-2/5">
                          Phone Number
                        </label>
                        <input
                          type="number"
                          name="phone"
                          id="phone"
                          placeholder="209 310 0333"
                          required
                          className="border border-customGray  hover:border-greenBg  rounded-lg bg-customGray w-full px-2 py-2 focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                        />
                      </p>
                      <p className="flex  p-2 items-center">
                        <label for="timezone" className="w-2/5">
                          Whats App Number
                        </label>
                        <input
                          type="number"
                          name="whatsapp"
                          id="whatsapp"
                          placeholder="+919814098140"
                          required
                          className="border border-customGray  hover:border-greenBg  rounded-lg bg-customGray w-full px-2 py-2 focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                        />
                      </p>

                      <p className=" p-2">
                        <label for="notes" className="w-2/5">
                          Notes
                        </label>
                        <textarea
                          name="notes"
                          id="notes"
                          rows={5}
                          cols={20}
                          className="border border-customGray  hover:border-greenBg  rounded-lg bg-customGray w-full px-2 py-2 mt-4 ml-2 focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                        ></textarea>
                      </p>
                    </div>
                    <div className="w-2/5">
                      <div>
                        <h1 className="text-[13px] font-bold">
                          Change Your Password
                        </h1>
                      </div>
                      <div>
                        <p className="flex gap-3 p-2 items-center">
                          <label for="timezone" className="w-1/5">
                            Current Password
                          </label>
                          <input
                            type="password"
                            name="currentpassword"
                            id="currentpassword"
                            placeholder="Enter"
                            required
                            className=" border border-customGray  hover:border-greenBg  rounded-lg bg-customGray w-full px-2 py-2 focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                          />
                        </p>
                        <p className="flex gap-3 p-2 items-center">
                          <label for="timezone" className="w-1/5">
                            New Password
                          </label>
                          <input
                            type="password"
                            name="newpassword"
                            id="newpassword"
                            placeholder="Enter"
                            required
                            className=" border border-customGray  hover:border-greenBg  rounded-lg bg-customGray w-full px-2 py-2 focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                          />
                        </p>
                        <p className="flex gap-3 p-2 items-center">
                          <label for="timezone" className="w-1/5">
                            Confirm New Password
                          </label>
                          <input
                            type="password"
                            name="confirmpassword"
                            id="confirmpassword"
                            placeholder="Enter"
                            required
                            className=" border border-customGray  hover:border-greenBg   rounded-lg bg-[#BDFFBC] w-full px-2 py-2 focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
        {showCalculator && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white  rounded-xl ">
           
            <Calculator onClose={() => setShowCalculator(false)} />
          </div>
        </div>
      )}
      
    </div>
  );
};

export default MyProfile;
